import router from '@/router'
import axios from '@/plugins/axios'

const moduleUser = {
	namespaced: true,
	state: {
		NICK_NAME: '' || localStorage.getItem('nickname'), // 用户昵称
		NAME_CHILD: true, // 玩家起名
	},
	mutations: {
		SET_NICK_NAME: (state, params) => {
			state.NICK_NAME = params
			localStorage.setItem('nickname', params)
		},
		REMOVE_NICK_NAME: state => {
			state.NICK_NAME = ''
			localStorage.removeItem('nickname')
		},
		SET_NAME_CHILD: (state, params) => {
			state.NAME_CHILD = params
		},
	},
	actions: {
		getUserInfo({ commit }) {
			return new Promise((resolve, reject) => {
				axios
					.get('/user/info')
					.then(v => {
						if (v.data.uid && v.data.nickname) {
							commit('SET_NICK_NAME', v.data.nickname)
							commit('SET_NAME_CHILD', true)
						} else {
							commit('SET_NAME_CHILD', false)
						}
						resolve(v)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
		logout({ commit }) {
			return new Promise((resolve, reject) => {
				axios
					.post('/user/logout')
					.then(v => {
            commit('REMOVE_NICK_NAME')
						resolve(v)
					})
					.catch(e => {
						reject(e)
					})
			})
		},
	},
	getters: {},
}

export default moduleUser
